import type { ReactNode } from 'react'

type EmptyStateProps = {
  icon: string
  title: string
  description?: string
  action?: ReactNode
  /** Compact removes the large vertical padding for use inside an existing card. */
  compact?: boolean
}

/** Mirror superoti-kitchen/src/shared/components/EmptyState.tsx. */
export function EmptyState({ icon, title, description, action, compact = false }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center text-center px-4 ${compact ? 'py-4' : 'py-10'}`}>
      <span
        className={`material-symbols-outlined text-primary/40 mb-2 ${compact ? 'text-[28px]' : 'text-[40px]'}`}
        aria-hidden
      >
        {icon}
      </span>
      <p className="text-body-lg font-semibold text-on-surface">{title}</p>
      {description && <p className="text-body-sm text-on-surface-variant mt-1 max-w-xs">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
